import { render } from "./SwiperSlide.vue?vue&type=template&id=5a7df186&scoped=true"
import script from "./SwiperSlide.vue?vue&type=script&lang=js"
export * from "./SwiperSlide.vue?vue&type=script&lang=js"

import "./SwiperSlide.vue?vue&type=style&index=0&id=5a7df186&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a7df186"]])

export default __exports__